import React from 'react';
import PropTypes from 'prop-types';
import { Button, List, Avatar, Row } from 'antd';
import SocialEdit from '../SocialEdit';
import { inputPropTypes } from '../SocialEdit/SocialEdit';

const SocialMediaCard = ({
  item,
  toggleSocialEdit,
  isModalOpened,
  onSubmit,
  typeInputProps,
  linkInputProps,
  modalTitle,
  isLoading,
  isError,
  errorMsg,
  isSuccess,
  successMsg,
  handleDelete,
}) => (
  <div>
    <List.Item key={item?.title}>
      <List.Item.Meta
        avatar={<Avatar src={item?.iconLink} />}
        title={
          <Row justify="space-between">
            <a href={item?.link}>
              {item.type.toUpperCase()} : {item.link}
            </a>
            <div>
              <Button onClick={toggleSocialEdit}>Edit</Button>
              {item.type !== 'facebook' && item.type !== 'instagram' && (
                <Button onClick={() => handleDelete(item?.type)}>Delete</Button>
              )}
            </div>
          </Row>
        }
      />
    </List.Item>
    <SocialEdit
      initialValues={item}
      isOpen={isModalOpened}
      toggle={toggleSocialEdit}
      onSubmit={onSubmit}
      linkTypeMenu={[]}
      typeInputProps={typeInputProps}
      linkInputProps={linkInputProps}
      modalTitle={modalTitle}
      isLoading={isLoading}
      isError={isError}
      errorMsg={errorMsg}
      isSuccess={isSuccess}
      successMsg={successMsg}
    />
  </div>
);

SocialMediaCard.propTypes = {
  item: PropTypes.object,
  toggleSocialEdit: PropTypes.func.isRequired,
  isModalOpened: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  modalTitle: PropTypes.string.isRequired,
  typeInputProps: PropTypes.shape(inputPropTypes),
  linkInputProps: PropTypes.shape(inputPropTypes),
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  errorMsg: PropTypes.string,
  isSuccess: PropTypes.bool,
  successMsg: PropTypes.string,
  handleDelete: PropTypes.func,
};

export default SocialMediaCard;
